import { Router } from 'react-router-dom'
import Routes from './routes'
import history from './history'
import { AuthProvider } from './context/AuthContext'
import 'bootstrap/dist/css/bootstrap.min.css'
import './App.css';

function App() {
    return (
        <AuthProvider>
            <Router history={history}>
                <Routes />
            </Router>
        </AuthProvider>
    )
}

export default App
